import(/* webpackMode: "eager" */ "/builds/sympla/comprador/discovery-next/src/app/global-error.tsx");
